import { render } from "./MakePredictionsRugby.vue?vue&type=template&id=b50ffea6&scoped=true"
import script from "./MakePredictionsRugby.vue?vue&type=script&lang=js"
export * from "./MakePredictionsRugby.vue?vue&type=script&lang=js"

import "./MakePredictionsRugby.vue?vue&type=style&index=0&id=b50ffea6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b50ffea6"]])

export default __exports__